export const GET_DISCUSSION = 'GET_DISCUSSION';
export const DELETE_DISCUSSION = "DELETE_DISCUSSION";